// <s-countdown> — live countdown to a sale's start, then its end. Hides its region after the end.
// Reads data-start / data-end (ms since epoch) and label text from data attributes. One component per file.
class SCountdown extends HTMLElement {
  #timer = null;

  connectedCallback() {
    this.#tick();
    this.#timer = window.setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.#timer);
  }

  #tick() {
    const start = Number(this.dataset.start) || 0;
    const end = Number(this.dataset.end) || 0;
    const now = Date.now();
    const region = this.closest("[data-countdown-region]") || this;

    if (!end || now > end) {
      if (this.dataset.designMode !== "true") region.hidden = true;
      window.clearInterval(this.#timer);
      this.#render(0);
      return;
    }

    const before = now < start;
    const label = this.querySelector("[data-countdown-label]");
    if (label) label.textContent = before ? this.dataset.labelStarts : this.dataset.labelEnds;
    this.#render((before ? start : end) - now);
  }

  #render(remaining) {
    const total = Math.max(0, Math.floor(remaining / 1000));
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [unit, value] of Object.entries(values)) {
      const el = this.querySelector(`[data-unit="${unit}"]`);
      if (el) el.textContent = String(value).padStart(2, "0");
    }
  }
}

if (!customElements.get("s-countdown")) {
  customElements.define("s-countdown", SCountdown);
}
